export { ConsoleInstrumentation } from './instrumentation';
